/**
 * External dependencies
 */
import debugFactory from 'debug';
import page from 'page';
import url from 'url';
import { parse } from 'qs';
import { once } from 'lodash';
import React from 'react';

/**
 * Internal dependencies
 */
import { setupRoutes } from 'sections-middleware';
import { setRoute as setRouteAction } from 'state/ui/actions';
import userFactory from 'lib/user';
import { hydrate } from 'lib/controller/utils';
import Preloader from 'components/preloader';

//new
import { createReduxStore } from 'state';
import initialReducer from 'state/reducer';
import { setCurrentUser } from 'state/current-user/actions';
import { getPreference } from 'state/preferences/selectors';

const debug = debugFactory('talink');

const setupContextMiddleware = (reduxStore) => {
	page('*', (context, next) => {
		// page.js url parsing is broken so we had to disable it with `decodeURLComponents: false`
		const parsed = url.parse(context.canonicalPath, true);
		context.prevPath = parsed.path === context.path ? false : parsed.path;
		context.query = parsed.query;

		context.hashstring = (parsed.hash && parsed.hash.substring(1)) || '';
		// set `context.hash` (we have to parse manually)
		if (context.hashstring) {
			try {
				context.hash = parse(context.hashstring);
			} catch (e) {
				debug('failed to query-string parse `location.hash`', e);
				context.hash = {};
			}
		} else {
			context.hash = {};
		}

		context.store = reduxStore;

		// client version of the isomorphic method for redirecting to another page
		context.redirect = (httpCode, newUrl = null) => {
			if (isNaN(httpCode) && !newUrl) {
				newUrl = httpCode;
			}

			return page.replace(newUrl, context.state, false, false);
		};

		next();
	});

	page.exit('*', (context, next) => {
		if (!context.store) {
			context.store = reduxStore;
		}
		next();
	});
};



const loggedInMiddleware = async (currentUser, reduxStore) => {
	if (!currentUser.get()) {
		return;
	}

	page('/logout', () => {
		currentUser.clear();
		return (window.location = '/login');
	});

	
	page('*', async (context, next) => {
		/*
		if (isLoaded(context.store.getState()) === false) {
			let context = {};
			// this causes a DIV tag mismatch warning
			context.layout = <Preloader />;
			hydrate(context);
		}
		*/
		next();
	});

};


const loadSectionsMiddleware = () => setupRoutes();

// do: check if the route is white listed
// hint: look at the routes in section
// if its not there, do something
const whitelistedSectionMiddleware = () => null;

// if the user is not logged in
// then some routes should not be accessible
// hint: make all routes not acceessible and add prop to skip
// const loggedOutMiddleware = (currentUser) => {
// 	// const queryParameters = new URLSearchParams(window.location.search);
// 	// const hmac = queryParameters.get("hmac");
//     // const host = queryParameters.get("host");
//     // const shop = queryParameters.get("shop");
//     // const timestamp = queryParameters.get("timestamp");
//     // const session = queryParameters.get("session");

// 	// if (currentUser.get() === null) {
// 	// 	if(hmac !== null) {
// 	// 		if(session !== null) {
//     //             const redirect = "/sgc/install&hmac="+hmac+"&host="+host+"&session="+session+"&shop="+shop+"&timestamp="+timestamp;
// 	// 			page.redirect('/login?redirect='+redirect);
// 	// 		} else {
// 	// 			const redirect = "/sgc/install&hmac="+hmac+"&host="+host+"&shop="+shop+"&timestamp="+timestamp;
// 	// 			page.redirect('/login?redirect='+redirect);
// 	// 		}
//     //     } else {
//     //         page.redirect('/login');
//     //     }
// 	// }

// 	const queryParameters = new URLSearchParams(window.location.search);
// 	const code = queryParameters.get("code");
// 	const hmac = queryParameters.get("hmac");
//     const host = queryParameters.get("host");
//     const shop = queryParameters.get("shop");
//     const timestamp = queryParameters.get("timestamp");
//     const session = queryParameters.get("session");

// 	if (currentUser.get() === null) {
// 		if(hmac !== null && code !== null && shop !== null && timestamp !== null) {
// 			if(session !== null) {
//                 const redirect = "/sgc/callback&code="+code+"&hmac="+hmac+"&host="+host+"&session="+session+"&shop="+shop+"&timestamp="+timestamp;
// 				page.redirect('/login?redirect='+redirect);
// 			} else {
// 				const redirect = "/sgc/callback&code="+code+"&hmac="+hmac+"&host="+host+"&shop="+shop+"&timestamp="+timestamp;
// 				page.redirect('/login?redirect='+redirect);
// 			}
//         } else {
//             page.redirect('/login');
//         }
// 	}
// };

const loggedOutMiddleware = (currentUser) => {
    const hasToken = !!localStorage.getItem('currentUserJWT');
    const pathname = window.location.pathname;

    console.log('loggedOutMiddleware - currentUser.get():', currentUser.get());
    console.log('loggedOutMiddleware - hasToken:', hasToken);
    console.log('loggedOutMiddleware - pathname:', pathname);

    // Whitelist public routes that don't require authentication
    const publicRoutes = ['/login', '/jwt-login'];
    if (publicRoutes.includes(pathname)) {
        return;  // ← don't redirect, let the route handle itself
    }

    if (currentUser.get() === null && !hasToken) {
        const queryParameters = new URLSearchParams(window.location.search);
        const code      = queryParameters.get("code");
        const hmac      = queryParameters.get("hmac");
        const host      = queryParameters.get("host");
        const shop      = queryParameters.get("shop");
        const timestamp = queryParameters.get("timestamp");
        const session   = queryParameters.get("session");

        if (hmac !== null && code !== null && shop !== null && timestamp !== null) {
            if (session !== null) {
                const redirect = "/sgc/callback&code="+code+"&hmac="+hmac+"&host="+host+"&session="+session+"&shop="+shop+"&timestamp="+timestamp;
                page.redirect('/login?redirect='+redirect);
            } else {
                const redirect = "/sgc/callback&code="+code+"&hmac="+hmac+"&host="+host+"&shop="+shop+"&timestamp="+timestamp;
                page.redirect('/login?redirect='+redirect);
            }
        } else {
            page.redirect('/login');
        }
    }
};

const setRouteMiddleware = () => {
	page('*', (context, next) => {
		context.store.dispatch(setRouteAction(context.pathname, context.query));
		next();
	});
};

// export const configureReduxStore = (reduxStore, currentUser) => {
// 	debug('Executing configure Redux store.');
// 	if (currentUser.get()) {
// 		reduxStore.dispatch(setCurrentUser(currentUser.get()));
// 	}
// };

export const configureReduxStore = (reduxStore, currentUser) => {
    debug('Executing configure Redux store.');
    const user = currentUser.get();
    console.log('currentUser.get():', user);  // ← add this
    if (user) {
        reduxStore.dispatch(setCurrentUser(user));
        console.log('Redux state after dispatch:', reduxStore.getState().currentUser);  // ← add this
    }
};

/**
 * [description]
 *
 * @param  {[type]} reduxStore [description]
 * @return {[type]}            [description]
 */
export const setupMiddlewares = (currentUser, reduxStore) => {
	debug('Executing setup middlewares.');
	setupContextMiddleware(reduxStore);
	loadSectionsMiddleware();
	whitelistedSectionMiddleware();
	loggedOutMiddleware(currentUser);
	loggedInMiddleware(currentUser, reduxStore);
	setRouteMiddleware();
};

const boot = (currentUser) => {
	const reduxStore = createReduxStore({}, initialReducer);
	configureReduxStore(reduxStore, currentUser);
	setupMiddlewares(currentUser, reduxStore);
	page.start({ decodeURLComponents: false });
};

export const bootApp = (appName) => {
	const user = userFactory();

	user.initialize().then(() => {
		debug(`Starting ${appName}`);
		boot(user);
	});
};
